module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/partner-two-9613b925e64aa30607ed525a81fe835a.png";